export default __webpack_public_path__ + "static/media/addIcon.dc7c4831.svg";